import Fetcher from "../fetcher/Fetcher";
import {getAnalyticsApiBaseURLForNetwork} from "./tinymanAnalyticsApiHelpers";

type AnalyticsApiVersions = ReturnType<typeof getAnalyticsApiBaseURLForNetwork>;

class TinymanAnalyticsApiManager {
  fetcher: {base: Fetcher; default: Fetcher};

  constructor(urls: AnalyticsApiVersions) {
    this.fetcher = {
      default: new Fetcher({baseUrl: urls.v1}),
      base: new Fetcher({baseUrl: urls.base})
    };
  }

  updateFetcher(urls: AnalyticsApiVersions) {
    this.fetcher = {
      default: new Fetcher({baseUrl: urls.v1}),
      base: new Fetcher({baseUrl: urls.base})
    };
  }
}

const tinymanAnalyticsApiManager = new TinymanAnalyticsApiManager(
  getAnalyticsApiBaseURLForNetwork()
);

export default tinymanAnalyticsApiManager;
